<template>

	<div v-if="isInitialized">
		<Navigation v-if="!isUnknownUser" @logout="handleLogout" />

		<div class="container mx-auto p-4 pb-24 md:pb-4">
			<SentryErrorBoundary>
				<router-view />
			</SentryErrorBoundary>
		</div>
		<ChangelogDialog />
	</div>
	<div v-else>
		<LoadingScreen />
	</div>
	<template v-if="needsOnboarding">
		<SentryErrorBoundary>
			<OnboardingModal />
		</SentryErrorBoundary>
	</template>

	<Toast />
	<ConfirmDialog />
	<LevelUpDialog />
	<Notifications />
</template>

<script setup lang="ts">
import Navigation from '@/components/Navigation.vue';
import LoadingScreen from '@/components/LoadingScreen.vue';
import { useAuthStore, useRanksStore, useUsersStore, useOnboardingStore } from '@/stores';
import { storeToRefs } from "pinia";
import ChangelogDialog from "@/components/notifications/ChangelogDialog.vue";
import { watch } from "vue";
import OnboardingModal from "@/components/onboarding/OnboardingModal.vue";
import LevelUpDialog from "@/components/level-up/LevelUpDialog.vue";
import Notifications from "@/components/notifications/Notifications.vue";
import Toast from "primevue/toast";
import SentryErrorBoundary from "./components/SentryErrorBoundary.vue";

const { ensureRanksLoaded } = useRanksStore();
const { isInitialized, isUnknownUser } = storeToRefs(useAuthStore());
const { ensureUsersLoaded } = useUsersStore();
const { ensureHouseholdLoaded } = useOnboardingStore();
const { needsOnboarding } = storeToRefs(useOnboardingStore());

watch([isInitialized, isUnknownUser], async (newValue) => {
	const [isInitialized, isUnknownUser] = newValue;
	if (isInitialized && !isUnknownUser) {
		await setupApp();
	}
}, { immediate: true });

async function setupApp() {
	await Promise.all([
		ensureRanksLoaded(),
		ensureUsersLoaded(),
		ensureHouseholdLoaded()
	]);
}

function handleLogout() {
	useAuthStore().logout();
}
</script>